import { styled } from '@sds-system/system';
import type {
  DescriptionsOptions,
  StyledDescriptionsTableProps,
  StyledDescriptionsTdProps,
  StyledDescriptionsThProps,
  StyledDescriptionsTrProps,
} from './Descriptions.types';

const descriptionsPaddingStyle = (size?: DescriptionsOptions['size']) => {
  switch (size) {
    case 'S':
      return {
        padding: '8px 16px',
      };
    case 'M':
      return {
        padding: '12px 24px',
      };
    case 'L':
      return {
        padding: '16px 24px',
      };
    default:
      return {
        padding: '16px 24px',
      };
  }
};

export const DescriptionsTable = styled('div')<StyledDescriptionsTableProps>(
  ({ theme, border, width, bgColor }) => {
    return {
      width: width ?? '100%',
      borderCollapse: 'collapse',
      border: border ?? `1px solid ${theme.palette.border.tertiary}`,
      backgroundColor: bgColor ?? theme.palette.system.white,
    };
  },
);

export const DescriptionsTr = styled('tr')<StyledDescriptionsTrProps>(({ theme, border }) => {
  return {
    borderBottom: border ?? `1px solid ${theme.palette.border.tertiary}`,
  };
});

export const DescriptionsTh = styled('th')<StyledDescriptionsThProps>(
  ({ theme, border, bgColor, size, textAlign }) => {
    return {
      borderRight: border ?? `1px solid ${theme.palette.border.tertiary}`,
      backgroundColor: bgColor ?? theme.palette.bg.tertiary,
      textAlign: textAlign ?? 'left',
      verticalAlign: 'middle',
      ...descriptionsPaddingStyle(size),
    };
  },
);

export const DescriptionsTd = styled('td')<StyledDescriptionsTdProps>(({ textAlign, size }) => {
  return {
    textAlign: textAlign ?? 'left',
    verticalAlign: 'middle',
    ...descriptionsPaddingStyle(size),
  };
});
